import styled from 'styled-components';
import { Link } from '@reach/router';
import { ListItem } from '@material-ui/core';
import { PRIMARY } from '../../../shared/styles/colors';

export const Logo = styled(Link)`
  width: 120px;
  height: 31px;
  cursor: pointer;
  text-decoration: none;
  margin: 15px auto 0px;
`;

export const Content = styled.section`
  padding: 0 18px 39px;
  width: 240px;
  box-sizing: border-box;

  @media (min-width: 600px) {
    padding: 0 39px 39px;
    min-width: 318px;
  }
`;

export const NavItem = styled(ListItem)`
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
  color: ${PRIMARY};
  height: 55px;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  & > .active {
    font-weight: 600;
  }

  & > a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }
`;

export const SocialLinksContainer = styled.nav`
  margin: 18px 0;
  text-align: center;
`;